import { isObject, isArray, isFunction, isSymbol } from '../is';
import { stringify, parse } from '../codec';
import { randomInt } from '../random';

// 数组去重 (数据顺序会保留)
export const deDuplication = <T = any>(arr: T[]) => Array.from(new Set(arr));

// 拷贝（不拷贝无法序列化的数据） - 默认浅拷贝，深拷贝设 deep 深度，设-1无限深（深拷贝自引用会导致死循环）
export const copy = <T>(origin: T, deep = 1): T | undefined => {
  // 深拷贝
  if (deep < 0) {
    return parse(stringify(origin));
  }
  // 赋值
  if (deep === 0) {
    return origin;
  }
  // 无法序列化;
  if (isFunction(origin) || isSymbol(origin)) {
    return undefined;
  }
  // 深浅拷贝
  // console.log(origin, toString.call(origin), isObject(origin), isArray(origin));
  if (isObject(origin)) {
    return arrToObj(Object.entries(origin), { mapValue: v => copy(v, deep - 1) }) as unknown as T;
  }
  if (isArray(origin)) {
    return (origin as unknown as any[]).map(v => copy(v, deep - 1)) as unknown as T;
  }
  return origin;
};

export const shallowCopy = <T>(origin: T) => copy<T>(origin) as T;
export const deepCopy = <T>(origin: T) => copy<T>(origin, -1) as T;

export interface ArrToObjOptions<T, K> {
  mapValue?: (v: T) => K
  keyName?: string
  valueName?: string
}

// arr => obj
export const arrToObj = <T, K = T>(arr: ArrayLike<any>, {
  mapValue = (v: T) => v as unknown as K,
  keyName = '0',
  valueName = '1',
}: ArrToObjOptions<T, K> = {}) => {
  const o: { [key: string]: K } = {};
  Array.from(arr).forEach(({ [keyName]: k, [valueName]: v }) => o[k as string] = mapValue(v));
  return o;
};

// TODO: obj => arr

// TODO: hashMap

// TODO: 打乱数组 check

// 打乱数组
export const shuffle = <T = any>(arr: T[]) => {
  const a = deepCopy(arr);
  a.forEach((_, i) => {
    const j = randomInt(a.length);
    [a[i], a[j]] = [a[j], a[i]];
  });
  return a;
};
